/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a49983d8c382c50f3beacc49b1258f7e51f068a2";
